









import { Component, Mixins } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { SUBMODULES_PATHS } from '../../../store';
import { FacetsGroupMixin } from '../../mixins/facets-group.mixin';

@Component({
  computed: {
    ...mapState(SUBMODULES_PATHS.search, ['numFound'])
  }
})
export default class ClearSelectedFiltersByGroup extends Mixins(FacetsGroupMixin) {
  numFound: number;

  get facetsNamesToClear() {
    return Object.keys(this.facetsGroup.facets);
  }

  get messageParameters() {
    return {
      numFound: this.numFound,
      selectedFiltersCount: this.groupSelectedFilters.length,
      selectedFilters: this.groupSelectedFilters.map(filter => filter.title).join(', ')
    };
  }
}
